import { render, staticRenderFns } from "./settings.vue?vue&type=template&id=7109d0e8&scoped=true&"
var script = {}
import style0 from "./settings.vue?vue&type=style&index=0&id=7109d0e8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7109d0e8",
  null
  
)

export default component.exports